import * as cateringConciergeCoordinators from './cateringConcierge'

export default Object.freeze({
  ...cateringConciergeCoordinators,
})
